import { mergeWith, isEmpty, isNull } from "lodash";

export const getNormalizedOrderSummary = (orderSummary) => {
  const details = {};
  orderSummary?.orderSummary.forEach((item) => {
    details[item.type] = item;
  });
  return details;
};

export const mergeWithContext = (serverValues, context) => {
  return mergeWith({}, serverValues, context, (a, b) =>
    isNull(a) || isEmpty(a) ? b : undefined
  );
};

export const getNormalizedPlans = (plans) => {
  /* sort asc */
  let normalizedPlans = plans.sort((a, b) =>
    a.boxCount < b.boxCount ? -1 : 1
  );
  /* add short name */
  normalizedPlans.map(
    (plan) => (plan.shortName = plan.name.replace(" Subscription", ""))
  );
  return normalizedPlans;
};

export const composeGiftPlans = (serverGiftPlans, cmsGiftPlans) =>
  serverGiftPlans.map((gp) => {
    const cmsData = cmsGiftPlans.references.find(
      (r) => r.component === String(gp.boxCount)
    );
    return { ...gp, cmsData };
  });
